module.exports = __webpack_public_path__ + "static/media/arrow-right.5d5f38e6.svg";